export default __webpack_public_path__ + "static/media/mcd_kr.6ff55220.png";